import { Fragment } from "react"
import dynamic from "next/dynamic"

const AudioBlocks = dynamic(() => import('@/components/AudioBlocks'))
const Media = dynamic(() => import('@/components/Media'))
const MediaPair = dynamic(() => import('@/components/MediaPair'))
const Pullquote = dynamic(() => import('@/components/Pullquote'))
const TextColumns = dynamic(() => import('@/components/TextColumns'))
const Copy = dynamic(() => import('@/components/Copy'))
const TextBlock = dynamic(() => import('@/components/TextBlock'))
const Accordion = dynamic(() => import('@/components/Accordion'))
const Statistics = dynamic(() => import('@/components/Statistics'))
const InfoBox = dynamic(() => import('@/components/InfoBox'))
const PartnerQuotes = dynamic(() => import('@/components/PartnerQuotes'))
const CareersBlock = dynamic(() => import('@/components/CareersBlock'))
const TeamMembers = dynamic(() => import('@/components/TeamMembers'))
const MediaListGrid = dynamic(() => import('@/components/MediaListGrid'))
const LogoGrid = dynamic(() => import('@/components/LogoGrid'))
const TestimonialCarousel = dynamic(() => import('@/components/TestimonialCarousel'))
const IframeBlock = dynamic(() => import('@/components/IframeBlock'))

interface ContentBlocksProps {
	contentBlocks: any[]
}

export default function ContentBlocks({contentBlocks}:ContentBlocksProps) {
	return (
		contentBlocks?.map((block, index) => (
			<Fragment key={`item-${block?._key}-${index}`}>

				{block?._type === 'copy' && <Copy heading={block?.heading} text={block?.text} />}

				{block?._type === 'textColumns' && <TextColumns textColumns={block?.columns} />}

				{block?._type === 'pullquote' && <Pullquote pullquote={block?.pullquote} author={block?.author} size={block?.size} />}

				{block?._type === 'media' && <Media media={block} />}

				{block?._type === 'mediaPair' && <MediaPair media1={block?.media1} media2={block?.media2} aspectRatio={block?.aspectRatio} />}

				{block?._type === 'audioBlock' && <AudioBlocks items={block?.items} backgroundImage={block?.backgroundImage} backgroundColour={block?.backgroundColour} />}

				{block?._type === 'iframeBlock' && <IframeBlock url={block?.url} aspectRatioDesktop={block?.aspectRatioDesktop} aspectRatioMobile={block?.aspectRatioMobile} />}

				{block?._type === 'textBlock' && <TextBlock text={block?.text} />}

				{block?._type === 'accordion' && <Accordion accordion={block?.accordion} />}

				{block?._type === 'statistics' && <Statistics version={block?.version} statistics={block?.statistics} />}

				{block?._type === 'infoBox' && <InfoBox {...block} />}

				{block?._type === 'partnerQuotes' && <PartnerQuotes {...block} />}

				{block?._type === 'careers' && <CareersBlock {...block} />}

				{block?._type === 'teamMembers' && <TeamMembers {...block} />}

				{block?._type === 'mediaListGrid' && <MediaListGrid heading={block?.heading} items={block?.items} />}

				{block?._type === 'logoGrid' && <LogoGrid heading={block?.heading} logos={block?.logos} />}

				{block?._type === 'testimonialCarousel' && <TestimonialCarousel testimonials={block?.testimonials} />}

			</Fragment>
		))
	)
}